import { useEffect, useState } from 'react'

import { leerNumero } from '../formato'

interface Props {
  /** El costo unitario que tiene la linea ahora (USD). */
  valor: number
  /** Ya no es el del catalogo: el asesor lo cambio para esta cotizacion. */
  modificado: boolean
  alCambiar: (nuevo: number) => void
  alRestablecer: () => void
  /** Para qué es el número (lector de pantalla). Por defecto, el costo unitario. */
  etiqueta?: string
  /** Qué hace «↺». Por defecto, volver al costo del catálogo. */
  tituloRestablecer?: string
  /** Tope del valor escrito; más allá se descarta como un valor inválido. */
  maximo?: number
}

const enTexto = (n: number) => String(n).replace('.', ',')

/**
 * El costo unitario de una linea, editable. Se confirma al salir del campo o con Enter (no
 * con cada tecla: cada cambio recalcula la cotizacion entera con el motor). Un valor que no
 * es un numero, o es negativo, se descarta y vuelve al anterior.
 */
export function CeldaCosto({ valor, modificado, alCambiar, alRestablecer, etiqueta = 'Costo unitario', tituloRestablecer = 'Volver al costo del catálogo', maximo }: Props) {
  const [texto, setTexto] = useState(enTexto(valor))
  useEffect(() => setTexto(enTexto(valor)), [valor])

  const confirmar = () => {
    const n = leerNumero(texto)
    if (n === null || Number.isNaN(n) || n < 0 || (maximo !== undefined && n > maximo)) {
      setTexto(enTexto(valor))
      return
    }
    if (n !== valor) alCambiar(n)
  }

  return (
    <span className={modificado ? 'celda-costo modificado' : 'celda-costo'}>
      <input
        className="entrada-costo"
        value={texto}
        inputMode="decimal"
        aria-label={etiqueta}
        onChange={(e) => setTexto(e.target.value)}
        onBlur={confirmar}
        onKeyDown={(e) => e.key === 'Enter' && e.currentTarget.blur()}
      />
      {modificado && (
        <button type="button" className="enlace pequeno" title={tituloRestablecer} onClick={alRestablecer}>
          ↺
        </button>
      )}
    </span>
  )
}
